import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'osn-shared-shimmer-loading',
  templateUrl: './shimmer-loading.component.html',
  styleUrls: ['./shimmer-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShimmerLoadingComponent {
  @Input() public width = 0;
  @Input() public height = 0;
  @Input() public useDynamicFullSize = false;

  public isAppRunningInBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private readonly platformId, private readonly elementRef: ElementRef) {
    this.isAppRunningInBrowser = isPlatformBrowser(this.platformId);
  }

  get dynamicWidth(): number {
    return this.getReferenceElement()?.offsetWidth ?? 0;
  }
  get dynamicHeight(): number {
    return this.getReferenceElement()?.offsetHeight ?? 0;
  }

  private getReferenceElement(): HTMLElement | null {
    const self = this.elementRef?.nativeElement as HTMLElement;
    return self?.parentElement ?? self;
  }
}
